import { Api } from './Api/Api';
import { Auth } from '../Utils/Auth';

const ENDPOINTS = {
  Login: 'recouv/api-token-auth',
  Logout: 'logout',
  Register: 'register',
  Password: 'init/password',
  Mail: 'forgot/password'
};

const login = async (payload, signal) => {
  try {
    // Ajouter access_type au payload
    const loginPayload = {
      ...payload,
      access_type: "formalite"
    };

    const response = await Api.post(ENDPOINTS.Login, loginPayload, signal);

    // Vérifier si la réponse existe
    if (!response || !response.data) {
      throw new Error('Réponse vide du serveur');
    }

    // Stocker le token et les informations utilisateur
    if (response?.data?.token && response?.data?.admin) {
      Auth.setSessionToken(response.data.token);
      Auth.setUser(response.data.admin);
      return response.data;
    } else if (response?.data?.access_token && response?.data?.user) {
      Auth.setSessionToken(response.data.access_token);
      Auth.setUser(response.data.user);
      return response.data;
    } else if (response?.data?.token) {
      Auth.setSessionToken(response.data.token);
      return response.data;
    }

    throw new Error('Format de réponse invalide');
  } catch (error) {
    // Relancer l'erreur pour que Login.js puisse la capturer
    throw error;
  }
};

const register = (payload, signal) => {
  return Api.post(ENDPOINTS.Register, payload, signal);
};

const resetPassword = (payload, signal) => {
  return Api.post(ENDPOINTS.Password, payload, signal);
};

const forgotPassword = (payload, signal) => {
  return Api.post(ENDPOINTS.Mail, payload, signal);
};

const logout = (navigate) => {
  Auth.removeSessionToken();

  if (navigate) {
    navigate('/auth/login');
  } else {
    window.location.replace('/auth/login');
  }
};

export const AuthService = {
  login,
  logout,
  register,
  resetPassword,
  forgotPassword
};